var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-r",
    clipPath: "url(#clip0_4263_26762)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6044 8.35399C4.71163 10.9295 7.07047 13.2883 9.64598 15.3956L10.3098 15.9387C11.5018 16.914 13.2389 16.8274 14.3279 15.7384L16.0433 14.0229L12.7821 10.7618L10.3363 13.2076L4.78254 7.6539L7.2366 5.21621L3.97704 1.95669L2.26164 3.67209C1.17262 4.76112 1.08599 6.49817 2.06124 7.69015L2.6044 8.35399ZM8.7698 16.4664C6.12314 14.3009 3.69905 11.8769 1.53357 9.23018L0.990399 8.56633C-0.434975 6.82416 -0.308349 4.28539 1.2833 2.69375L3.97704 0L9.1965 5.21948L6.74251 7.65722L10.3363 11.251L12.7821 8.80514L18 14.0229L15.3062 16.7167C13.7146 18.3084 11.1759 18.435 9.43374 17.0096L8.7698 16.4664Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4263_26762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5e2e57c1d23ea1c18e42129e7033375e.svg";
export { ForwardRef as ReactComponent };